<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} Código Error Traces</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="inpErrorTraces">Error Traces</label>
                                <input formControlName="ErrorTraces" name="ErrorTraces" maxlength="150" title=""
                                       [ngClass]="displayFieldCss('ErrorTraces')"
                                       class="form-control" id="inpErrorTraces" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('ErrorTraces','required')">
                                    Error Traces es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('ErrorTraces','descripcion_duplicated')">
                                    Error Traces ya existe
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpDescripcionError">Descripción Error</label>
                                <input formControlName="DescripcionError" name="DescripcionError" maxlength="150" title=""
                                       [ngClass]="displayFieldCss('DescripcionError')"
                                       class="form-control" id="inpDescripcionError" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('DescripcionError','required')">
                                    Descripción Error es obligatoria
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpMensajeError">Mensaje Error</label>
                                <input formControlName="MensajeError" name="MensajeError" title="" maxlength="150" [ngClass]="displayFieldCss('MensajeError')"
                                       class="form-control" id="inpCodigo" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('MensajeError','required')">
                                    Mensaje Error es obligatorio
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
